module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<span class=\'network-container\'>\n    <div class=\'network-editor-icon sharing ' +
__e( style ) +
' ' +
__e( state.id ) +
'\'></div>\n</span>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/socialSharingWidget/SocialSharingWidgetFormatSelection.tpl
// module id = 2098
// module chunks = 0